import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";

import { formatMoney, signOf } from "@/shared/lib";

/**
 * Сумма с окраской по знаку.
 *
 * Цвет берётся из токенов темы, а не из палитры: админка живёт и в светлой, и
 * в тёмной теме, а зелёный из светлой на тёмном фоне нечитаем.
 *
 * При `colored` к цвету добавляется стрелка: цвет в таблице легко потерять
 * среди соседних колонок, а направление — нет.
 */
export function Money({
  value,
  sign = "auto",
  colored = false,
  suffix = null,
}: {
  value: string;
  sign?: "auto" | "always";
  colored?: boolean;
  suffix?: string | null;
}) {
  const direction = signOf(value);
  const neutral = !colored || direction === "zero";
  const color = neutral
    ? undefined
    : direction === "positive"
      ? "var(--ant-color-success)"
      : "var(--ant-color-error)";

  return (
    <span
      style={{
        color,
        whiteSpace: "nowrap",
        fontVariantNumeric: "tabular-nums",
        fontWeight: neutral ? 500 : 600,
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
      }}
    >
      {!neutral && (
        <span aria-hidden style={{ fontSize: "0.8em" }}>
          {direction === "positive" ? <CaretUpOutlined aria-hidden /> : <CaretDownOutlined aria-hidden />}
        </span>
      )}
      {formatMoney(value, { sign, suffix })}
    </span>
  );
}
